import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSyncAlt } from "react-icons/fa";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

const MarketOverview = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [search, setSearch] = useState("");

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleRefresh = () => {
    console.log("Refresh clicked");
  };

  return (
    <div className="wrapper">
      {/* Sidebar */}
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      {/* Header */}
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      {/* Content */}
      <div
        className={`content-wrapper ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{
          marginLeft: !isMobile && isSidebarOpen ? "" : "0",
          transition: "margin-left 0.3s ease",
          minHeight: "100vh",
        //   background: "#f4f6f9",
        }}
      >
        <section className="content  px-2">
          <div className="container-fluid">

            {/* Top Header Row */}
            <div className="d-flex justify-content-between align-items-center  p-3 rounded " style={{    background: "rgb(240, 240, 240)"}}>
              
              {/* Left Side Title */}
              <div className="d-flex align-items-center gap-2">
                <h4 className="mb-0 text-black fs-4">Market Analysis</h4>
                <FaSyncAlt
                  style={{ cursor: "pointer" }}
                  onClick={handleRefresh}
                  className="mt-3 text-black"
                />
              </div>

              {/* Right Side Search */}
              <div style={{ width: "150px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Event"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

            </div>

            {/* Empty Body Area */}
            <div
              className="mt-3 rounded"
              style={{
                height: "70vh",
                // background: "#ffffff",
                // border: "1px solid #e5e5e5",
              }}
            >
              {/* Content will come here */}
            </div>

          </div>
        </section>
      </div>
    </div>
  );
};

export default MarketOverview;
